// Matches hrefs that already have a scheme (http:, https:, mailto:, tel:, ...),
// are root-relative ("/..."), or are same-page anchors ("#...").
const HAS_SCHEME_OR_RELATIVE = /^([a-z][a-z0-9+.-]*:|\/|#)/i;

/**
 * Rich-text content lets authors type a bare domain (e.g. "rameshdev.in")
 * as a link without a protocol. Browsers then treat that href as relative
 * to the current page instead of an external site. This rewrites any such
 * href to an absolute https:// URL, and opens external links in a new tab
 * so they don't navigate away from the SPA in the same window.
 */
const normalizeContentLinks = (html = "") => {
  if (!html) return html;

  const doc = new DOMParser().parseFromString(html, "text/html");
  doc.querySelectorAll("a[href]").forEach((anchor) => {
    const href = anchor.getAttribute("href");
    if (!href || HAS_SCHEME_OR_RELATIVE.test(href)) return;

    anchor.setAttribute("href", `https://${href}`);
    anchor.setAttribute("target", "_blank");
    anchor.setAttribute("rel", "noopener noreferrer");
  });

  return doc.body.innerHTML;
};

export default normalizeContentLinks;
